import React, { Component } from 'react';
import { Paper, Typography, Button } from "@material-ui/core";
import SystemDeviceFaultsPieChartInverters from './SystemDeviceFaultsPieChartInverters';
import SystemDeviceFaultsPieChartErrors from './SystemDeviceFaultsPieChartErrors';
import '../../index.css';

class SystemDeviceFaultsPieCharts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeChart: 'inverters', // Default to showing inverters
    };
  }

  setActiveChart = (chartName) => {
    this.setState({ activeChart: chartName });
  }

  render() {
    const { activeChart } = this.state;

    return (
        <Paper className="FaultsPieChart">
  <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px', justifyContent: 'space-between' }}>
    <div>
      <Button 
        className={`chart-item ${activeChart === 'inverters' ? 'active' : 'inactive-tab'}`}
        onClick={() => this.setActiveChart('inverters')}
        style={{ margin: '0 10px' }}
      >
        Inverters
      </Button>
      <Button 
        className={`chart-item ${activeChart === 'errors' ? 'active' : 'inactive-tab'}`}
        onClick={() => this.setActiveChart('errors')}
      >
        Errors
      </Button>
    </div>
    <Typography className="SmartOMTitle" variant="h6" color="primary" style={{ textAlign: 'center', flexGrow: 1 }}>
      Error Frequency Chart
    </Typography>
    <div style={{ width: '130px' }}> {/* This div acts as a spacer on the right to center the title */}
    </div>
  </div>
  <div style={{ overflowX: 'auto' }}>
    {activeChart === 'inverters' ? (
      <SystemDeviceFaultsPieChartInverters />
    ) : (
      <SystemDeviceFaultsPieChartErrors />
    )}
  </div>
</Paper>
      
    );
  }
}

export default SystemDeviceFaultsPieCharts;
